import { FieldName, VisibilitySliceType } from '../components/enums';
import type { ContactFormFieldSlice } from '../components/types';

interface OverrideExistingSliceParams {
  slices: ContactFormFieldSlice[];
  fieldName: FieldName;
  overrides: Partial<ContactFormFieldSlice>;
}

const CHANNEL_SLICE: ContactFormFieldSlice = {
  type: 'text_field',
  fieldName: FieldName.Channel,
  fieldType: null,
  required: true,
};

export const overrideExistingSlice = ({
  slices,
  fieldName,
  overrides,
}: OverrideExistingSliceParams) =>
  slices.map(slice => {
    if (slice.fieldName === fieldName) {
      return {
        ...slice,
        ...overrides,
      };
    }

    return slice;
  });

export const getSlicesWithChannelFields = (slices: ContactFormFieldSlice[]) => {
  const newSlices = overrideExistingSlice({
    slices,
    fieldName: FieldName.Phone,
    overrides: { required: true },
  });

  return [...newSlices, CHANNEL_SLICE];
};

export const removeChannelSelectionSlice = (
  slices: ContactFormFieldSlice[]
): ContactFormFieldSlice[] =>
  slices.filter(({ type }) => type !== VisibilitySliceType.CallbackSolution);

const SELLER_CONTACT_FIELDS = [FieldName.ProductName, FieldName.Comment];

export const getSellerContactSlices = (slices: ContactFormFieldSlice[]): ContactFormFieldSlice[] =>
  slices
    .filter(({ fieldName }) => SELLER_CONTACT_FIELDS.includes(fieldName))
    .map(slice =>
      slice.fieldName === FieldName.ProductName ? { ...slice, required: true } : slice
    );
